// extracted by mini-css-extract-plugin
export default {"indicator":"ErrorIndicator_indicator__zQMRF","hasErrors":"ErrorIndicator_hasErrors__mwn0Q","noErrors":"ErrorIndicator_noErrors__vyCIR"};